module.exports = __webpack_public_path__ + "static/media/headsup.49263b3b.png";